import { nsSig } from '../img/ns-sig';

export const formS1627 = (dateExtension: string): any[] => [
  {
    text: 'Thank you for your recent request for your personal information, as permitted under the California Consumer Privacy Act.',
    marginBottom: 10
  },
  {
    text: [
      { text: 'We will respond to your request by ' },
      { text: dateExtension + '.', bold: true }
    ],
    marginBottom: 10
  },
  {
    text: 'We may contact you for additional information to verify your identity. In the event we are unable to fulfill your request within 45 days, we will notify you of the reason for the delay and may take up to an additional 45 days to respond to your request.',
    marginBottom: 10
  },
  {
    text: [
      { text: 'Rest assured, SAFE is committed to maintaining strong privacy programs that adhere to strict data privacy and security requirements. To learn more, please visit ' },
      { text: 'safecu.org/privacy. ', bold: true },
    ],
    marginBottom: 10
  },
  {
    text: 'If  you  have  any  questions,  please  feel  free  to  contact  a  helpful  SAFE  representative  at'
  },
  {
    text: [
      { text: '(916) 979-7233 ', bold: true },
      { text: 'or ' },
      { text: '(800) SEE-SAFE.', bold: true }
    ],
    marginBottom: 10
  },
  { text: 'Sincerely,', marginBottom: 5, marginTop: 10 },
  { image: nsSig, width: 140, marginBottom: 5 },
  { text: 'Nicole Smith' },
  { text: 'VP, Contact Center' },
  { text: 'SAFE Credit Union' }
]
